import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { routeConfig } from "routeConfig";
import { getRouteDisplayName } from "utils/routeDisplayName";

export default function RoutePageTitle() {
  const { pathname } = useLocation();
  const { t } = useTranslation("routes");
  const route = routeConfig.find((item) => item.route === pathname);
  return route ? getRouteDisplayName(route, t) : null;
}
